import { RouteComponentProps } from 'react-router-dom';

import styles from './styles.module.scss';

export const Terms: React.FC<RouteComponentProps> = () => {
  return (
    <div className={styles.container}>
      <div>
        <div>
          <h1>Terms and Conditions</h1>
          <p>Please read these terms and conditions carefully before using Our Service.</p>
        </div>
        <div>
          <h1>Acknowledgment</h1>
          <p>
            These are the Terms and Conditions governing the use of this Service and the agreement
            that operates between You and the Company. These Terms and Conditions set out the rights
            and obligations of all users regarding the use of the Service.
          </p>
          <p>
            Your access to and use of the Service is conditioned on Your acceptance of and
            compliance with these Terms and Conditions. These Terms and Conditions apply to all
            visitors, users and others who access or use the Service.
          </p>
          <p>
            By accessing or using the Service You agree to be bound by these Terms and Conditions.
            If You disagree with any part of these Terms and Conditions then You may not access the
            Service.
          </p>
          <p>
            You represent that you are over the age of 18. The Company does not permit those under
            18 to use the Service.
          </p>
          <p>
            Your access to and use of the Service is also conditioned on Your acceptance of and
            compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our
            policies and procedures on the collection, use and disclosure of Your personal
            information when You use the Application or the Website and tells You about Your privacy
            rights and how the law protects You. Please read Our Privacy Policy carefully before
            using Our Service.
          </p>
          <p>
            By accessing or using the Service, you acknowledge that the Company merely offers the
            tools and resources to connect those seeking tradie services with those seeking to
            provide such services.You understand and agree thatthe Company: (a) is not a party to
            any transactions between users; (b) does not employ, recommend or endorse any users and
            has no control over the acts or omissions of any users; (c) is not responsible or liable
            in any manner for the performance or conduct of any users or other third parties online
            or offline; (d) makes no representations or warranties about the quality of the services
            provided by any users or about your interactions or dealings with other users; and (e)
            does not screen users or conduct any kind of identity or background checks with respect
            to users. You should therefore exercise caution and perform your own diligence and
            screening before connecting with anyone through the Service, meeting anyone, engaging
            users or accepting engagements. The Company hereby expressly disclaims, and you hereby
            expressly release the Company from, any and all liability whatsoever for any
            controversies, claims, suits, injuries, loss, harm and/or damages arising from and/or in
            any way related to the Service or your interactions or dealings with other users,
            including without limitation any acts and/or omissions of users online or offline. By
            accessing or using the Service, you acknowledge and agree that you are solely
            responsible for your use of the Service and theconnections you make and that all use of
            the Service is at your sole and exclusive risk.
          </p>
        </div>
        <div>
          <h1>Representation & Warranties</h1>
          <p>
            You are responsible for providing accurate, current, and complete information in
            connection with your Account, you commit to keeping such information up-to-date and
            accurate, and you will register your Account in your own legal name.
          </p>
          <p>
            To open an Account, you also represent and warrant that you meet the following
            eligibility criteria:
          </p>
          <ul>
            <li>
              You are 18 years of age or older and if you have child dependent(s) seventeen (17)
              years of age or younger, then you are acknowledging and agreeing to these Terms on
              their behalf as well;
            </li>
            <li>
              You have the need for, and/or have the capacity and willingness to the tradie
              services.
            </li>
            <li>
              Neither you nor any member of your household, your home, or the location where care
              services are provided or received (a) has ever been the subject of a complaint,
              restraining order or any other legal action involving violence, abuse, neglect, fraud,
              larceny, or any offense that involves endangering the safety of others, dishonesty,
              negligence, or drugs, or otherwise arrested for, charged with, or convicted of a
              felony or any criminal offense involving the above; (b) has ever been convicted of a
              crime of any nature, including any felony or misdemeanor of any kind, including
              without limitation any sexual, child abuse, or domestic violence offenses; (c) has
              ever been registered, is currently registered, and/or is currently required to
              register as a sex offender in any jurisdiction or with any government entity; or (d)
              is currently out on bail or pending trial relating to any felony or misdemeanor
              charges of any kind, including without limitation sexual, child abuse, or domestic
              violence offenses.
            </li>
          </ul>
          <p>
            If you do not meet the above eligibility requirements, do not register to use the
            Service.The Company reserves the right to immediately suspend or terminate your Account
            for any violation of the foregoing requirements, or otherwise for knowingly providing
            any information of a false, untrue, inaccurate, or incomplete nature, in each case at
            its sole discretion.
          </p>
        </div>
        <div>
          <h1>Subscriptions</h1>
          <h2>Subscription period</h2>
          <p>
            The Service or some parts of the Service are available only with a paid Subscription.
            You will be billed in advance on a recurring and periodic basis (such as daily, weekly,
            monthly or annually), depending on the type of Subscription plan you select when
            purchasing the Subscription.
          </p>
          <p>
            At the end of each period, Your Subscription will automatically renew under the exact
            same conditions unless You cancel it or the Company cancels it.
          </p>
          <h2>Subscription cancellations</h2>
          <p>
            You may cancel Your Subscription renewal either through Your Account settings page or by
            contacting the Company. You will not receive a refund for the fees You already paid for
            Your current Subscription period and You will be able to access the Service until the
            end of Your current Subscription period.
          </p>
          <p>
            If the Subscription has been made through an In-app Purchase, You can cancel the renewal
            of Your Subscription with the Application Store.
          </p>
          <h2>Billing</h2>
          <p>
            You shall provide the Company with accurate and complete billing information including
            full name, address, state, postal/zip code, telephone number, and a valid payment method
            information.
          </p>
          <p>
            Should automatic billing fail to occur for any reason, the Company will issue an
            electronic invoice indicating that you must proceed manually, within a certain deadline
            date, with the full payment corresponding to the billing period as indicated on the
            invoice. If the Subscription has been made through an In-app Purchase, all billing is
            handled by the Application Store and is governed by the Application Store&apos;s own
            terms conditions.
          </p>
          <h2>Fee Changes</h2>
          <p>
            The Company, in its sole discretion and at any time, may modify the Subscription fees.
            Any Subscription fee change will become effective at the end of the then-current
            Subscription period.
          </p>
          <p>
            The Company will provide You with reasonable prior notice of any change in Subscription
            fees to give You an opportunity to terminate Your Subscription before such change
            becomes effective.
          </p>
          <p>
            Your continued use ofthe Service after the Subscription fee change comes into effect
            constitutes Your agreement to pay the modified Subscription fee amount.
          </p>
          <h2>Refunds</h2>
          <p>Except when required by law, paid Subscription fees are non-refundable.</p>
          <p>
            Certain refund requests for Subscriptions may be considered by the Company on a
            case-by-case basis and granted at the sole discretion of the Company.
          </p>
          <p>
            If the Subscription has been made through an In-app purchase, the Application
            Store&apos;s refund policy will apply. If You wish to request a refund, You may do so by
            contacting the Application Store directly.
          </p>
          <h2>Free Trial</h2>
          <p>
            The Company may, at its sole discretion, offer a Subscription with a Free Trial for a
            limited period of time.
          </p>
          <p>
            You may be required to enter Your billing information in order to sign up for the Free
            Trial.
          </p>
          <p>
            If You do enter Your billing information when signing up for a Free Trial, You will not
            be charged by the Company until the Free Trial has expired. On the last day of the Free
            Trial period, unless You cancelled Your Subscription, You will be automatically charged
            the applicable Subscription fees for the type of Subscription You have selected.
          </p>
          <p>
            At any time and without notice, the Company reserves the right to (i) modify the terms
            and conditions of the Free Trial offer, or (ii) cancel such Free Trial offer.
          </p>
        </div>
        <div>
          <h1>In-app Purchases</h1>
          <p>
            The Application may include In-app Purchases that allow you to buy products, services or
            Subscriptions.
          </p>
          <p>
            More information about how you may be able to manage In-app Purchases using your Device
            may be set out in the Application Store&apos;s own terms and conditions or in your
            Device&apos;s Help settings.
          </p>
          <p>
            In-app Purchases can only be consumed within the Application. If you make a In-app
            Purchase, that In-app Purchase cannot be cancelled after you have initiated its
            download. In-app Purchases cannot be redeemed for cash or other consideration or
            otherwise transferred.
          </p>
          <p>
            If any In-app Purchase is not successfully downloaded or does not work once it has been
            successfully downloaded, we will, after becoming aware of the fault or being notified to
            the fault by You, investigate the reason for the fault. We will act reasonably in
            deciding whether to provide You with a replacement In-app Purchase or issue You with a
            patch to repair the fault. In no event will We charge You to replace or repair the
            In-app Purchase. In the unlikely event that we are unable to replace or repair the
            relevant In-app Purchase or are unable to do so within a reasonable period of time and
            without significant inconvenience to You, We will authorize the Application Store to
            refund You an amount up to the cost of the relevant In-app Purchase. Alternatively, if
            You wish to request a refund, You may do so by contacting the Application Store
            directly.
          </p>
          <p>
            You acknowledge and agree that all billing and transaction processes arehandled by the
            Application Store from where you downloaded the Application and are governed by that
            Application Store&apos;s own terms and conditions.
          </p>
          <p>
            If you have any payment related issues with In-app Purchases, then you need to contact
            the Application Store directly.
          </p>
        </div>
        <div>
          <h1>User Accounts</h1>
          <p>
            When You create an account with Us, You must provide Us information that is accurate,
            complete, and current at all times. Failure to do so constitutes a breach of the Terms,
            which may result in immediate termination of Your account on Our Service.
          </p>
          <p>
            You are responsible for safeguarding the password that You use to access the Service and
            for any activities or actions under Your password, whether Your password is with Our
            Service or a Third-Party Social Media Service.
          </p>
          <p>
            You agree not to disclose Your password to any third party. You must notify Us
            immediately upon becoming aware of any breach of security or unauthorized use of Your
            account.
          </p>
          <p>
            You may not use as a username the name of another person or entity or that is not
            lawfully available for use, a name or trademark that is subject to any rights of another
            person or entity other than You without appropriate authorization, or a name that is
            otherwise offensive, vulgar or obscene.
          </p>
        </div>
        <div>
          <h1>Content</h1>
          <h2>Your Right to Post Content</h2>
          <p>
            Our Service allows You to post Content. You are responsible for the Content that You
            post to the Service, including its legality, reliability, and appropriateness.
          </p>
          <p>
            By posting Content to the Service, You grant Us the right and license to use, modify,
            publicly perform, publicly display, reproduce, and distribute such Content on and
            through the Service. You retain any and all of Your rights to any Content You submit,
            post or display on or through the Service and You are responsible for protecting those
            rights. You agree that this license includes the right for Us to make Your Content
            available to other users of the Service, who may also use Your Content subject to these
            Terms.
          </p>
          <p>
            You represent and warrant that: (i) the Content is Yours (You own it) or You have the
            right to use it and grant Us the rights and license as provided in these Terms, and (ii)
            the posting of Your Content on or through the Service does not violate the privacy
            rights, publicity rights, copyrights, contract rights or any other rights of any person.
          </p>
          <h2>Content Restrictions</h2>
          <p>
            The Company is not responsible for the content of the Service&apos;s users. You
            expressly understand and agree that You are solely responsible for the Content and for
            all activity that occurs under your account, whether done so by You or any third person
            using Your account.
          </p>
          <p>
            You may not transmit any Content that is unlawful, offensive, upsetting, intended to
            disgust, threatening, libelous, defamatory, obscene or otherwise objectionable. Examples
            of such objectionable Content include, but are not limited to, the following:
          </p>
          <ul>
            <li>Unlawful or promoting unlawful activity.</li>
            <li>
              Defamatory, discriminatory, or mean-spirited content, including references or
              commentary about religion, race, sexual orientation, gender, national/ethnic origin,
              or other targeted groups.
            </li>
            <li>
              Spam, machine –or randomly –generated, constituting unauthorized or unsolicited
              advertising, chain letters, any other form of unauthorized solicitation, or any form
              of lottery or gambling.
            </li>
            <li>
              Containing or installing any viruses, worms, malware, trojan horses, orother content
              that is designed or intended to disrupt, damage, or limit the functioning of any
              software, hardware or telecommunications equipment or to damage or obtain unauthorized
              access to any data or other information of a third person.
            </li>
            <li>
              Infringing on any proprietary rights of any party, including patent, trademark, trade
              secret, copyright, right of publicity or other rights.
            </li>
            <li>
              Impersonating any person or entity including the Company and its employees or
              representatives.
            </li>
            <li>Violating the privacy of any thirdperson.</li>
            <li>False information and features.</li>
          </ul>
          <p>
            The Company reserves the right, but not the obligation, to, in its sole discretion,
            determine whether or not any Content is appropriate and complies with this Terms, refuse
            or remove this Content. The Company further reserves the right to make formatting and
            edits and change the manner any Content. The Company can also limit or revoke the use of
            the Service if You post such objectionable Content. As the Company cannot control all
            content posted by users and/or third parties on the Service, you agree to use the
            Service at your own risk. You understand that by using the Service You may be exposed to
            content that You may find offensive, indecent, incorrect or objectionable, and You agree
            that under no circumstances will the Company be liable in any way for any content,
            including any errors or omissions in any content, or any loss or damage of any kind
            incurred as a result of your use of any content.
          </p>
          <h2>Content Backups</h2>
          <p>
            Although regular backups of Content are performed, the Company do not guarantee there
            will be no loss or corruption of data.
          </p>
          <p>
            Corrupt or invalid backup points may be caused by, without limitation, Content that is
            corrupted prior to being backed up or that changes during the time a backup is
            performed.
          </p>
          <p>
            The Company will provide support and attempt to troubleshoot any known or discovered
            issues that may affect the backups of Content. But You acknowledge that the Company has
            no liability related to the integrity of Content or the failure to successfully restore
            Content to a usable state.
          </p>
          <p>
            You agree to maintain a complete and accurate copy of any Content in a location
            independent of the Service.
          </p>
        </div>
        <div>
          <h1>Copyright Policy</h1>
          <h2>Intellectual Property Infringement</h2>
          <p>
            We respect the intellectual property rights of others. It is Our policy to respond to
            any claim that Content posted on the Service infringes a copyright or other intellectual
            property infringement of any person.
          </p>
          <p>
            You may be held accountable for damages (including costs and attorneys&apos; fees) for
            misrepresenting thatany Content is infringing Your copyright.
          </p>
        </div>
        <div>
          <h1>Your Feedback to Us</h1>
          <p>
            You assign all rights, title and interest in any Feedback You provide the Company. If
            for any reason such assignment is ineffective, You agree to grant the Company a
            non-exclusive, perpetual, irrevocable, royalty free, worldwide right and license to use,
            reproduce, disclose, sub-license, distribute, modify and exploit such Feedback without
            restriction.
          </p>
        </div>
        <div>
          <h1>Links to Other Websites</h1>
          <p>
            Our Service may contain links to third-party web sites or services that are not owned or
            controlled by the Company.
          </p>
          <p>
            The Company has no control over, and assumes no responsibility for, the content, privacy
            policies, or practices of any third party web sites or services. You further acknowledge
            and agree that the Company shall not be responsible or liable, directly or indirectly,
            for any damage or loss caused or alleged to be caused by or in connection with the use
            of or reliance on any such content, goods or services available on or through any such
            web sites or services.
          </p>
          <p>
            We strongly advise You to read the terms and conditions and privacy policies of any
            third-party web sites or services that You visit.
          </p>
        </div>
        <div>
          <h1>Termination</h1>
          <p>
            We may terminate or suspend Your Account immediately, without prior notice or liability,
            for any reason whatsoever, including without limitation if You breach these Terms and
            Conditions.
          </p>
          <p>
            Upon termination, Your right to use the Service will cease immediately. If You wish to
            terminate Your Account, You may simply discontinue using the Service.
          </p>
        </div>
        <div>
          <h1>Governing Law</h1>
          <p>
            The laws of the Country, excluding its conflicts of law rules, shall govern this Terms
            and Your use of the Service. Your use of the Application may also be subject to other
            local, state, national, or international laws.
          </p>
        </div>
        <div>
          <h1>Disputes Resolution</h1>
          <p>
            If You have any concern or dispute about the Service, You agree to first try to resolve
            the dispute informally by contacting the Company.
          </p>
        </div>
        <div>
          <h1>Changes to These Terms and Conditions</h1>
          <p>
            We reserve the right, at Our sole discretion, to modify or replace these Terms at any
            time. If a revision is material We will make reasonable efforts to provide at least 30
            days&apos; notice prior to any new terms taking effect. What constitutes a material
            change will be determined at Our sole discretion.
          </p>
          <p>
            By continuing to access or use Our Service after those revisions become effective, You
            agree to be bound by the revised terms. If You do not agree to the new terms, in whole
            or in part, please stop using the website and the Service.
          </p>
        </div>
      </div>
    </div>
  );
};
